import { render, staticRenderFns } from "./CarAttest.vue?vue&type=template&id=7281ceca&"
import script from "./CarAttest.vue?vue&type=script&lang=js&"
export * from "./CarAttest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7281ceca')) {
      api.createRecord('7281ceca', component.options)
    } else {
      api.reload('7281ceca', component.options)
    }
    module.hot.accept("./CarAttest.vue?vue&type=template&id=7281ceca&", function () {
      api.rerender('7281ceca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/CarAttest.vue"
export default component.exports